import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setFilters } from '../../redux/inboxSlice';
import InboxPage from '../inbox/InboxPage';

// Instagram DMs already flow through the same generic Conversation/InboxMessage
// models as WhatsApp (channel: 'instagram') — no separate messaging UI needed,
// just pre-filter the existing unified inbox to this channel.
export default function InstagramMessagesTab() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setFilters({ channel: 'instagram' }));
  }, [dispatch]);

  return <InboxPage />;
}
